// 🌐 Global JavaScript libraries
import './libs/jquery.js';
import './libs/bootstrap.js';
import './libs/toastr.js';
import './libs/sweetalert.js';
import './libs/feather.js';
import './libs/moment.js';
import './libs/cropper.js';

// 📦 Component-based libraries
import { initSelect2 } from './libs/select2.js';
import { initDropify } from './libs/dropify.js';
import { initCKEditor } from './libs/ckeditor.js';

// 🚀 Page load initialization
window.addEventListener('load', () => {
    // Initialize only if elements exist
    initSelect2();
    initDropify();
    initCKEditor();

    // Enable feather icons
    feather.replace();

    // Set up AJAX CSRF token (for Laravel, etc.)
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content
        }
    });

});


document.addEventListener('DOMContentLoaded', () => {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach(el => new bootstrap.Tooltip(el));
});